import { render, staticRenderFns } from "./Identifiers.vue?vue&type=template&id=73f8963e&"
import script from "./Identifiers.vue?vue&type=script&lang=js&"
export * from "./Identifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports